import { useState } from "react"
import { useNavigate } from "react-router-dom";
import routes from "../constants/routes"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Box from "@mui/material/Box"
import TabPanel from "../components/ui/TabPanel"
import Courses from "../components/academic/Courses"
import Programs from "../components/academic/Programs"
import TabLogo from "../components/common/TabLogo"
import { Stack } from "@mui/material"

const Academic = ({tab}) => {
  const [value, setValue] = useState(tab || 0)
  const navigate = useNavigate()
  const handleChange = (_, newValue) => {
    setValue(newValue)
    switch(newValue) {
      case 0:
        navigate(routes.ACADEMIC.PROGRAMS, {replace: true})
        break
      case 1:
        navigate(routes.ACADEMIC.COURSES, {replace: true})
        break
      default:
        navigate(routes.ACADEMIC.PROGRAMS, {replace: true})
    }
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Stack direction="row" sx={{ borderBottom: 1, borderColor: "divider" }}>
        <TabLogo />{" "}
        <Tabs
          value={value}
          onChange={handleChange}
          scrollButtons
          allowScrollButtonsMobile
        >
          <Tab label="Programs" />
          <Tab label="Courses" />
        </Tabs>
      </Stack>

      <TabPanel value={value} index={0}>
        <Programs />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Courses />
      </TabPanel>
    </Box>
  )
}

export default Academic
